import { render } from "./Improvement.vue?vue&type=template&id=28c69e49&scoped=true"
import script from "./Improvement.vue?vue&type=script&lang=js"
export * from "./Improvement.vue?vue&type=script&lang=js"

import "./Improvement.vue?vue&type=style&index=0&id=28c69e49&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28c69e49"]])

export default __exports__